import { useQuery } from "react-query";
import { getTexasGrouping } from "../../../../../actions/Utilities/TexasGrouping";

export default function useGetTexasGroupings () {
  return useQuery("GetTexasGroupings",getTexasGrouping, {
    refetchOnWindowFocus: false,
  });
}